import type React from 'react';
import { Box, Title } from '@nimbus-ds/components';
import useTranslationOrders from 'domains/Orders/useTranslationOrders';

interface PaymentDetailsTitleProps {
  origin: string;
}

function PaymentDetailsTitle({
  origin,
}: Readonly<PaymentDetailsTitleProps>): React.JSX.Element | null {
  const t = useTranslationOrders('cardPayment');

  if (origin !== 'pos') {
    return null;
  }

  return (
    <Box paddingBottom="4">
      <Title as="h5" color="neutral-textHigh">
        {t('posPaymentDetails')}
      </Title>
    </Box>
  );
}

export default PaymentDetailsTitle;
